// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Vz6w1","wide":"modal_wide__hb6lh","overlay":"modal_overlay__g3kZY"};